import styles from '../../MagicUpload.module.scss';
import clsx from 'clsx';
import { useAppSelector } from '../../../../app/hooks';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { getUntaggedCount } from '../../MagicUploadHelper';
import { updateUntaggedMuFileNumber } from '../../../../store/investor/action';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { resolveAssesseeOrgId } from '../../Utils/MagicUploadUtils';

type MagicUploadTabSelectorProps = {
    tabState: string;
    setTabState: Dispatch<SetStateAction<'new' | 'tagged' | 'all'>>;
};

const MagicUploadTabSelector = (props: MagicUploadTabSelectorProps) => {
    const { tabState, setTabState } = props;
    const untaggedCount = useAppSelector((state) => state.investor.untaggedCount);
    const dispatch = useDispatch();
    const user = useAppSelector((state) => state.user);
    const params = useParams();
    const [searchParams] = useSearchParams();
    const isCompany = searchParams.get('isCompany') === 'true';

    // Fallback to storage if Redux isn't hydrated yet (prevents 401 on page refresh)
    // investorOrgId uses org_id from storage (platform org)
    const investorOrgId = user.userData.investorOrgId || sessionStorage.getItem('org_id') || localStorage.getItem('org_id') || '';
    const isBorrowerReq = searchParams.get('borrowerReq') === 'true';
    const assesseeOrgId =
        resolveAssesseeOrgId({
            isCompany,
            isBorrowerReq,
            orgIdFromQuery: searchParams.get('orgId'),
            orgIdFromRoute: params.id,
            orgIdFromRedux: user.userData.assesseeOrgId,
        }) ?? '';

    const getUntaggedStatus = async () => {
        // Guard: Don't make API call if required IDs are missing (prevents 401 on page refresh)
        const orgIdForCompany = assesseeOrgId || params.id;
        if (!investorOrgId || (isCompany && !orgIdForCompany)) return;

        await getUntaggedCount(
            {
                pnoId: investorOrgId,
                ...(isCompany && { orgId: orgIdForCompany }),
            },
            {
                onSuccess: (res) => {
                    dispatch(updateUntaggedMuFileNumber(res));
                },
            },
        );
    };
    useEffect(() => {
        const fetchUntaggedStatus = async () => {
            await getUntaggedStatus();
        };
        fetchUntaggedStatus();
    }, [investorOrgId, assesseeOrgId, params.id, isCompany]);
    return (
        <div className={styles.TabSelector}>
            <div
                onClick={() => setTabState('all')}
                className={clsx({
                    [styles.Tab]: true,
                    [styles.Active]: tabState === 'all',
                })}
            >
                All
            </div>
            <div
                onClick={() => setTabState('tagged')}
                className={clsx({
                    [styles.Tab]: true,
                    [styles.Active]: tabState === 'tagged',
                })}
            >
                Tagged
            </div>
            <div
                onClick={() => setTabState('new')}
                className={clsx({
                    [styles.Tab]: true,
                    [styles.Active]: tabState === 'new',
                })}
            >
                Untagged <span style={{ color: '#B4B4B4' }}>{untaggedCount}</span>
            </div>
        </div>
    );
};

export default MagicUploadTabSelector;
